import { useState, useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import QuickPinchZoom, { make3dTransformValue } from 'react-quick-pinch-zoom';
import { isBrowser } from 'react-device-detect';

import styles from './index.css';

export interface ImageProp {
    wrapperClassName?: string;
    className?: string;
    reset?: boolean;
    src: string;
    width?: number;
    height?: number;
}

const Image: React.FC<ImageProp> = ({
    wrapperClassName,
    className,
    reset,
    src,
    width = 400,
    height = 400,
}) => {
    const imgRef = useRef<HTMLDivElement>(null);
    const zoomerRef = useRef<QuickPinchZoom>(null);

    const [zoom, updateZoom] = useState(1);

    const onUpdate = useCallback(({ x, y, scale }) => {
        const { current: img } = imgRef;

        if (img) {
            const value = make3dTransformValue({ x, y, scale });
            img.style.setProperty('transform', value);
            updateZoom(scale);
        }
    }, []);

    useEffect(() => {
        if (reset) {
            zoomerRef.current?.alignCenter({
                x: width / 2,
                y: height / 2,
                scale: 1,
            });
        }
    }, [reset]);

    return (
        <div
            className={classnames(styles.wrapper, wrapperClassName)}
            onClick={() => {
                if (isBrowser) {
                    zoomerRef.current?.alignCenter({
                        x: width / 2,
                        y: height / 2,
                        scale: zoom > 2 ? -zoom : 3,
                    });
                }
            }}
            onKeyPress={() => {}}
            role="menuitem"
            tabIndex={0}
            onContextMenu={(e) => {
                e.preventDefault();
                return false;
            }}
        >
            <QuickPinchZoom
                ref={zoomerRef}
                onUpdate={onUpdate}
                minZoom={1}
                maxZoom={4}
                // tapZoomFactor={zoom > 2 ? -zoom : 2}
                tapZoomFactor={1}
            >
                <div
                    ref={imgRef}
                    className={classnames(
                        styles.image,
                        zoom > 2 ? styles.zoomout : styles.zoomin,
                        className,
                    )}
                    style={{
                        backgroundImage: `url(${src})`,
                        width,
                        height,
                    }}
                />
            </QuickPinchZoom>
        </div>
    );
};

export default Image;
